import { UilCheckCircle, UilTimes } from "@iconscout/react-unicons";
import React from "react";

function ServicesModal({ title, showModal, setShowModal, services }) {
  const [first, second] = title.split(" ");
  const { web, mobile, testing, support } = services;

  return (
    <div
      className={`services__modal ${showModal ? "" : "services__modal-show"}`}
    >
      <div className="services__modal-content">
        <h4 className="services__modal-title">
          {first} <br /> {second}
        </h4>
        <UilTimes
          className="services__modal-close"
          onClick={() => setShowModal(!showModal)}
        />

        <ul className="services__modal-services grid">
          {first === "Web"
            ? web.map((item) => {
                const { id, desc } = item;
                return (
                  <li className="services__modal-service" key={id}>
                    <UilCheckCircle className="services__modal-icon" />
                    <p>{desc}</p>
                  </li>
                );
              })
            : first === "Rigorous" ? testing.map((item) => {
                const { id, desc } = item;
                return (
                  <li className="services__modal-service" key={id}>
                    <UilCheckCircle className="services__modal-icon" />
                    <p>{desc}</p>
                  </li>
                );
              })
            : first === "Ongoing" ? support.map((item) => {
                const { id, desc } = item;
                return (
                  <li className="services__modal-service" key={id}>
                    {/* <UilCheckCircle className="services__modal-icon" /> */}
                    <p>{desc}</p>
                  </li>
                );
              })
            : mobile.map((item) => {
                const { id, desc } = item;
                return (
                  <li className="services__modal-service" key={id}>
                    <UilCheckCircle className="services__modal-icon" />
                    <p>{desc}</p>
                  </li>
                );
              })
              }
        </ul>
      </div>
    </div>
  );
}

export default ServicesModal;
